export const LANGUAGE_SELECTOR_LOCALSTORAGE_KEY = 'is-language-choosen';
export const DEFAULT_LANGUAGE = 'English';
